import React, { useMemo } from "react";
import { customSanitize } from "@/utils/customSanitize";
import { hasParagraphTag } from "@/utils/hasParagraphTag";

const BLOCK_TAG_RE =
  /<\/?(address|article|aside|blockquote|div|dl|dt|dd|fieldset|figcaption|figure|footer|form|h[1-6]|header|hr|li|main|nav|ol|p|pre|section|table|thead|tbody|tfoot|tr|td|th|ul|iframe)\b/i;

export const ContentTag = ({
  content,
  extraClass = "",
  isQuote = false,
}: {
  content: string;
  extraClass?: string;
  isQuote?: boolean;
}) => {
  const safe = useMemo(() => String(customSanitize(content ?? "")), [content]);
  const hasBlockTags = useMemo(() => BLOCK_TAG_RE.test(safe), [safe]);
  const paragraphClass = useMemo(
    () => (hasParagraphTag(safe) ? "p" : ""),
    [safe],
  );
  const pClassName = useMemo(
    () => extraClass.replace("inherit-parent", ""),
    [extraClass],
  );

  if (isQuote) {
    return (
      <blockquote
        className={`${paragraphClass} ${extraClass}`.trim()}
        dangerouslySetInnerHTML={{ __html: safe }}
      />
    );
  }

  if (hasBlockTags) {
    return (
      <div className={extraClass} dangerouslySetInnerHTML={{ __html: safe }} />
    );
  }

  return (
    <p className={pClassName} dangerouslySetInnerHTML={{ __html: safe }} />
  );
};
